import React, { useEffect, useRef } from 'react';
import { prop } from 'ramda';

import { useTranslations } from '@core/js/hooks/i18n';
import { useUserSelector } from '@core/js/store/hooks';

import { useAdaChat } from '@interlayer/js/custom/hooks/useAdaChat';
import { clsx } from '@interlayer/js/utils/classNames.util';

import style from '../FloatingButtons.scss';

export const AdaChat: React.FC = () => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const t = useTranslations('playtech.mobile.system.floating-button.');
    const { isAdaLoaded, toggleAdaChat } = useAdaChat();
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // because there is a problem with css hover MWSSG-4618
        const setManualHover = () => {
            const adaBtn = containerRef.current;

            if (!adaBtn || !isLoggedIn) {
                return;
            }

            const setHover = (event: MouseEvent) => {
                if (event.relatedTarget instanceof HTMLIFrameElement) {
                    return;
                }

                adaBtn.classList.add(style.isHovered);
            };

            const hideHover = () => {
                adaBtn.classList.remove(style.isHovered);
            };

            adaBtn.addEventListener('mouseenter', setHover);
            adaBtn.addEventListener('mouseleave', hideHover);

            return () => {
                adaBtn.removeEventListener('mouseenter', setHover);
                adaBtn.removeEventListener('mouseleave', hideHover);
            };
        };

        return setManualHover();
    }, [isLoggedIn]);

    if (!isLoggedIn) {
        return null;
    }

    return (
        <div
            ref={containerRef}
            className={clsx(style.item, style.isAdaChat, { [style.isDisabled]: !isAdaLoaded })}
            onClick={toggleAdaChat}
        >
            <div className={style.icon} />

            <span className={style.title}>{t('ada-chat')}</span>
        </div>
    );
};
